/* State hook for opening the SourceInfoDialog from feed items.
   Returns the dialog state props and a handler to pass as onSourceClick. */

import { useState, useCallback } from "react";
import type { Id } from "../../convex/_generated/dataModel";

export function useSourceInfoDialog() {
  const [sourceId, setSourceId] = useState<Id<"sources"> | null>(null);
  const [open, setOpen] = useState(false);

  const handleSourceClick = useCallback((id: string) => {
    setSourceId(id as Id<"sources">);
    setOpen(true);
  }, []);

  return {
    sourceInfoProps: { sourceId, open, onOpenChange: setOpen },
    handleSourceClick,
  };
}
